import type { ReactNode } from "react";
import { useMemo } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { FiltersChip } from "app/pages/sales-intelligence/common-components/filters-panel";

import type FindAppsPriceFilter from "../../../models/PriceFilter/PriceFilter";

import formatChipsContent from "./utils/formatChipsContent";

const AppsPriceFilterResult = ({ value, onFilterUpdate }: IFilterViewBaseProps<FindAppsPriceFilter>): ReactNode => {
    const text: string = useMemo((): string => {
        if (!value) {
            return "";
        }

        return formatChipsContent(value);
    }, [value]);

    if (!value || !value?.type) {
        return null;
    }

    return (
        <Flex>
            <FiltersChip
                text={text}
                onClose={() => onFilterUpdate()}
            />
        </Flex>
    );
};

export default AppsPriceFilterResult;
